export const navigationPaths = {
  globalView: '/global-view',
  adminTool: '/admin-tool',
  turbines: '/turbines',
  locations: '/locations',
  companies: '/companies',
  locationsDetails: '/locations/:siteId',
  turbinesDetails: '/turbines/:id',
  turbinesDetailsTab: '/turbines/:id/:tab?',
  audit: '/audit'
};

export const navigationPathsList = [
  { id: 'globalView', label: 'Global View', path: navigationPaths.globalView },
  { id: 'adminTool', label: 'Admin Tool', path: navigationPaths.adminTool },
  { id: 'turbines', label: 'Turbines', path: navigationPaths.turbines },
  { id: 'locations', label: 'Locations', path: navigationPaths.locations },
  { id: 'companies', label: 'Companies', path: navigationPaths.companies },
  {
    id: 'locationsDetails',
    label: 'Location Details',
    path: navigationPaths.locationsDetails
  },
  {
    id: 'turbinesDetailsTab',
    label: 'Turbine Details',
    path: navigationPaths.turbinesDetailsTab
  },
  {
    id: 'audit',
    label: 'Audit',
    path: navigationPaths.audit
  }
];

export const socketsEntities = {
  pulseSiteSummary: 'PulseSiteSummary',
  pulseTurbineSummary: 'PulseTurbineSummary',
  globalView: 'GlobalView'
};

export const detailViewRoutes = ['/locations/', '/turbines/'];

export const isDetailViewRoute = (pathname: string): boolean => {
  return detailViewRoutes.some(route => pathname.includes(route));
};
